import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ArtisanTeam } from '../_utils/_interfaces/team.interface';
import { LotPricing } from '../_utils/_interfaces/team-lot-pricing.interface';
import { CeProjectService } from '.';
import { map } from 'rxjs/operators';
import { offerLotPrice } from '../pages/04-architect/05-analyse-offres/archi-analyse-offres-lot/lot-comparison.helpers';

@Injectable()
export class TeamService {

  constructor(private ceProjectService: CeProjectService) { }

  saveTeams(teams: Array<any>, ceProjectId: string): Observable<boolean> {
    const data: any[] = teams.map(team => {
      const lots = team.lotPricing || team.lots || [];
      const savedTeam: any = {
        id: team.id,
        title: team.title,
        type: team.type || 'custom',
        // inviteId: the company of the offer, stable while the pricing _id changes at every submission.
        lots: lots.map((lot: any) => ({
          lotId: lot.idLot || lot.lotId,
          dpgfId: lot.idpricing || lot.pricingId,
          ...(lot.inviteId ? { inviteId: lot.inviteId } : {})
        }))
      };
      if(savedTeam.type === 'automatic') savedTeam.strategy = team.strategy;
      return savedTeam;
    });
    data.push({ id: 'hypotheses-v2', type: 'settings', title: '', lots: [] });
    return this.ceProjectService.update(ceProjectId, { teams: data }).pipe(map(() => true));
  }
  getTeams(ceProject, pricingList): Observable<ArtisanTeam[]> {
    return new Observable(sub => {
      this.ceProjectService.getProject(ceProject).subscribe(value => {
        const teams = (value.teams || []).filter((team: any) => !team.type || team.type === 'custom');
        if(teams.length === 0) {
          sub.error([]);
          sub.complete();
        }

        const teamsArray: ArtisanTeam[] = [];
        teams.forEach(team => {
          const pricings: LotPricing[] = [];

          team.lots.forEach(lot => {
            pricings.push(this.getPricing(lot.dpgfId, lot.lotId, pricingList, lot.inviteId));
          });
          const t: ArtisanTeam = new ArtisanTeam(team.title);
          t.lotPricing = pricings;
          teamsArray.push(t);
        });

        sub.next(teamsArray);
        sub.complete();
      });
    })
  }
  // The saved pricing _id changes at every submission (a new copy of the offer is saved):
  // fall back on the same company (inviteId), then on the ids the offer had (pricingIds).
  private findPricing(dpgfId, lot, pricings: any[], inviteId?): any {
    const hasLot = pricing => (pricing?.data || []).some(item => item?.id === lot);
    const inviteOf = pricing => String(pricing?.ceProjectInvite?._id || pricing?.ceProjectInvite || '');
    return pricings.find(pricing => pricing._id === dpgfId && hasLot(pricing))
      || (inviteId ? pricings.find(pricing => inviteOf(pricing) === String(inviteId) && hasLot(pricing)) : null)
      || pricings.find(pricing => (pricing?.pricingIds || []).some(id => String(id) === String(dpgfId)) && hasLot(pricing));
  }
  private getPricing(dpgfId, lot, pricings: any[], inviteId?): LotPricing {
    const pricing = this.findPricing(dpgfId, lot, pricings || [], inviteId);
    const lotData = pricing ? pricing.data.find(item => item?.id === lot) : null;
    if(lotData) {
      let factieArtisanTeam = pricing.ceProjectInvite?.facticeArtisanInfo?.name || pricing.artisanName;
      let artisanName = pricing.ceProjectInvite?.isFactice ? factieArtisanTeam : pricing.artisan?.name;

      // Net of the lot discount, as on the hypotheses page.
      const lotPricing = new LotPricing(lot, pricing._id, artisanName,
        offerLotPrice(lotData, pricing).total, pricing.dpgf);

      lotPricing.currentVersion = pricing.currentVersion;
      lotPricing.posts = this.getPosts(lotData.sousLots);
      return lotPricing;
    }
    const p = new LotPricing(lot, "", "", -1, dpgfId);
    p.isModifying = true;
    return p;
  }
  public getPosts(sousLots) {
      const posts = [];
      for(let i in sousLots) {
          for(let j in sousLots[i].postes){
            let post = sousLots[i].postes[j];
            post.sousLoti = i;
            posts.push(post);
          }

      }
      return posts;
  }
}
